import { api } from './authService';

export const segmentTemplatesService = {
  async list(organizationId) {
    const res = await api.get('/api/v2/segments/templates', { params: { organization_id: organizationId } });
    return Array.isArray(res.data) ? res.data : [];
  },
  async get(id) {
    const res = await api.get(`/api/v2/segments/templates/${id}`);
    return res.data;
  },
  async create({ name, description, criteria, organization_id, md5_count, sort_order }) {
    const res = await api.post('/api/v2/segments/templates', {
      name,
      description,
      criteria,
      organization_id,
      md5_count,
      sort_order,
    });
    return res.data;
  },
  async update(id, { name, description, criteria, md5_count }) {
    const res = await api.put(`/api/v2/segments/templates/${id}`, { name, description, criteria, md5_count });
    return res.data;
  },
  async remove(id) {
    await api.delete(`/api/v2/segments/templates/${id}`);
  },
};

/** FastCube admins can read/write templates for any organization (mirrors backend `is_fastcube_admin`). */
export function canManageTemplates(user) {
  return Boolean(user?.is_admin && user?.is_fastcube);
}
